import { clearStoredSession } from "./auth.storage";
import { clearSsoRelayGuards } from "./sso-relay-guard";
import { clearReturnTo } from "../modules/suite-navigation";
import { AUTH_REFRESH_PROBE_KEY } from "./auth.constants";

const SESSION_SEEDED_KEY = "itaas.suite.sessionSeededAt";

/** Purge locale complète (tokens, navigation SSO, relais). */
export function purgeAuthState(): void {
  clearStoredSession();
  clearReturnTo();
  clearSsoRelayGuards();
  if (typeof sessionStorage !== "undefined") {
    sessionStorage.removeItem(SESSION_SEEDED_KEY);
  }
  if (typeof localStorage !== "undefined") {
    localStorage.removeItem("itaas.suite.lastModule");
    localStorage.removeItem(AUTH_REFRESH_PROBE_KEY);
  }
  if (typeof sessionStorage !== "undefined") {
    sessionStorage.removeItem(AUTH_REFRESH_PROBE_KEY);
  }
}
